package com.karawek.core.ui.theme

import androidx.compose.runtime.Composable
import androidx.compose.ui.text.TextStyle

/**
 * Semantic typography accessors.
 *
 * These map to platform-specific typography through [CoreTheme.typography].
 */
object CoreTypography {
    val display: TextStyle
        @Composable get() = CoreTheme.typography.display

    val headline: TextStyle
        @Composable get() = CoreTheme.typography.headline

    val title: TextStyle
        @Composable get() = CoreTheme.typography.title

    val title2: TextStyle
        @Composable get() = CoreTheme.typography.title2

    val title3: TextStyle
        @Composable get() = CoreTheme.typography.title3

    val body: TextStyle
        @Composable get() = CoreTheme.typography.body

    val callout: TextStyle
        @Composable get() = CoreTheme.typography.callout

    val bodySecondary: TextStyle
        @Composable get() = CoreTheme.typography.bodySecondary

    val caption: TextStyle
        @Composable get() = CoreTheme.typography.caption

    val footnote: TextStyle
        @Composable get() = CoreTheme.typography.footnote
}
